import React from "react";
import { ActionIcon, Box } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import Logo from "../Logo/Logo";
import styles from "./FullscreenShell.module.css";

interface FullscreenShellProps {
  /** Slot rendered top-left of the top bar (e.g. a Back button in checkout). */
  topLeft?: React.ReactNode;
  /** Renders the top-bar ✕. */
  onClose: () => void;
  /** Left (main) column content. */
  left: React.ReactNode;
  /** Right (summary) column content — sticky on desktop. */
  right: React.ReactNode;
  closeAriaLabel?: string;
}

/**
 * Fullscreen paper-layout chrome: a slim top bar (Back slot · centered
 * Pagoda logo · ✕) that sticks to the top on mobile, a centered 1120px
 * container, and a 1fr/372px column grid with a sticky right column on
 * desktop. On mobile the columns stack; action buttons inside the right
 * column stick to the bottom of the screen (see surface `.mobileActions`).
 */
export default function FullscreenShell({
  topLeft,
  onClose,
  left,
  right,
  closeAriaLabel = "Close",
}: FullscreenShellProps) {
  return (
    <Box className={styles.page}>
      <Box className={styles.topBar}>
        <Box className={styles.topBarSide}>{topLeft}</Box>
        <Logo variant="icon" size="xs" alt="Pagoda" />
        <Box className={`${styles.topBarSide} ${styles.topBarRight}`}>
          <ActionIcon
            variant="subtle"
            className={styles.closeButton}
            onClick={onClose}
            aria-label={closeAriaLabel}
            size={36}
          >
            <IconX size={18} />
          </ActionIcon>
        </Box>
      </Box>
      <Box className={styles.grid}>
        <Box className={styles.leftColumn}>{left}</Box>
        <Box className={styles.rightColumn}>{right}</Box>
      </Box>
    </Box>
  );
}
